import React, { useContext,useState,useEffect  } from "react";
import { UserContext } from "../contexts/UserContext";
import { Card, CardBody, CardFooter, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Icon } from "@iconify/react/dist/iconify.js";
import fileDocumentEditOutline from '@iconify/icons-mdi/file-document-edit-outline';
import { SrxApi } from '../api/SrxApi';

const SecureFormsModal = ({ pharmacy, facility, toggle }) => {
    const { user } = useContext(UserContext);
    const [secureFormConfigs, setSecureFormConfigs] = useState([]);
    const [loading, setLoading] = useState(false);

    let mediprocityFormsBaseUrl = 'https://secure-forms.mediprocity.com/forms/';

   function returnFormPharm(pharmID) {
        switch (pharmID.toLowerCase()) {
            case 'kyrx':
                return returnFormPharm('ohio')
            default:
                return pharmID.toUpperCase();
        }
    }

        const renderForm = (form) => {
        const link = formLink(form);
        if (form.label === 'covid vaccine independent contractor') {
            // Use formLink to check if the form should be rendered or hidden
            return formLink(form) !== null;
        }
        return true;

    };

    const getFacilityName = (key) => `${key ?? 'facility_name'}=${encodeURIComponent(facility?.facName ?? '')}`;

    const getDate = (key) => `${key ?? 'date'}=${encodeURIComponent(new Date().toLocaleDateString('en-US'))}`;

    const getName = (key) => `${key ?? 'name'}=${encodeURIComponent(user?.displayName ?? '')}`;

    const formLink = (form) => {
        // SPRX form links
        if (form.label === 'OTC Override Authorization Form') {
            return [`${mediprocityFormsBaseUrl}${form.id}?`,
                `fill_from_url=true`,
                `${getFacilityName()}`
            ].join('&');
        }

        if (form.label === 'covid vaccine independent contractor' && facility.facState?.toLowerCase() !== 'nj') {
            return null;
        }

        if (form.label === 'Out on Pass Medication Form') {
            return [`${mediprocityFormsBaseUrl}${form.id}?`,
                `fill_from_url=true`,
                `${getFacilityName()}`,
                `${getName('nurse_name')}`,
                `${getDate('today_date')}`,
                `${getName('type_sign_1')}`,
                `${getDate('date_1')}`
            ].join('&');

        } else if (form.label === 'Vaccine Request Form') {
            return [`${mediprocityFormsBaseUrl}${form.id}?`,
                `fill_from_url=true`,
                `${getFacilityName()}`,
                `${getDate()}`,
                `${getName('individual_ordering')}`,
                `${getDate('date_1')} `
            ].join('&');

        } else if (form.label === 'Reorder Medication Form') {
            return [`${mediprocityFormsBaseUrl}${form.id}?`,
                `fill_from_url=true`,
                `${getFacilityName()}`,
                `${getName('facility_rep')}`,
                `${getDate()}`
            ].join('&');

        } else if (form.label === 'T.E.D. Stocking Order Form') {
            return [`${mediprocityFormsBaseUrl}${form.id}?`,
                `fill_from_url=true`,
                `${getFacilityName()}`,
                `${getName('facility_rep')}`,
                `${getDate()}`
            ].join('&');

        } else if (form.label === 'covid vaccine independent contractor') {
            return [`${mediprocityFormsBaseUrl}${form.id}?`,
                `fill_from_url=true`,
                `${getDate('independent_contractor_agreement_date')}`,
                `${getFacilityName('contractor')}`,
                `state_name_2_checkbox=${encodeURIComponent(facility.facState?.toLowerCase() === 'nj' ? 'Yes' : 'No')}`,
                `state_name_2=${encodeURIComponent(facility.facState?.toLowerCase() === 'nj' ? '' : facility.facState)}`,
                `state_name_3_checkbox=${encodeURIComponent(facility.facState?.toLowerCase() === 'nj' ? 'Yes' : 'No')}`,
                `state_name_3=${encodeURIComponent(facility.facState?.toLowerCase() === 'nj' ? '' : facility.facState)}`,
                `${getFacilityName()}`,
                `${getDate()}`,
                `type_sign_1=${encodeURIComponent(user.displayName)}`,
                `${getName('name')}`,
                `title=${encodeURIComponent(user.hasOwnProperty('title') ? user.title : '')}`
            ].join('&');
        }
    };

    useEffect(() => {
        if (pharmacy?.pharmID || facility?.pharmID) {
            setLoading(true);
            SrxApi.get(`/secureformconfigs/${pharmacy?.pharmID || facility?.pharmID}`)
                .then((res) => {
                    console.log('API Response:', res);
                    // Extract data if wrapped in response object
                    const rows = res?.data || res;
                    const formConfigs = Array.isArray(rows) ? rows.map((r) => ({
                         id: r.secureFormID || r.SecureFormID || r.id || '',
                        label: r.title || r.Title || r.label || '',
                        pharmID: (r.pharmID || r.PharmID || r.PharmId || '')?.toString(),
                        raw: r
                    })) : rows;
                    setSecureFormConfigs(formConfigs);
                    setLoading(false);
                })
                .catch((err) => {
                    console.error('API Error:', err);
                    setSecureFormConfigs([]);
                    setLoading(false);
                });
        } else {
            setSecureFormConfigs([]);
        }
    }, [facility]);

    return (
        <Modal centered isOpen={!!facility} toggle={toggle}>
            {facility ? (
                <>
                    <ModalHeader
                        className="gradient-modal"
                        toggle={toggle}
                        style={{
                            background: 'linear-gradient(90deg, #452f69 0%, #452f69 50%, #000 90%)',
                            color: 'white',
                        }}>
                        {facility.facName}
                    </ModalHeader>
                    <ModalBody>
                        <>
                            <Row>
                                <Col>
                                    <p>
                                        Facility ID: <b>{facility.facID}</b>
                                    </p>
                                    <p>
                                        Facility Name: <b>{facility.facName}</b>
                                    </p>
                                    <p>
                                        Pharmacy ID: <b>{pharmacy?.pharmID || facility.pharmID}</b>
                                    </p>
                                </Col>
                            </Row>
                            <hr className="my-0" />
                            <Row>
                                <Col>
                                    <h3>Forms: </h3>
                                </Col>
                            </Row>
                            <Row>
                                {loading ? (
                                    <div>Loading forms...</div>
                                ) : Array.isArray(secureFormConfigs) && secureFormConfigs.length > 0 ? (
                                    secureFormConfigs.map((form) => (
                                                <Col md={6} style={{ minWidth: '200px', display: renderForm(form) ? 'block' : 'none' }}>
                                                    {renderForm(form) && (
                                                        <a href={formLink(form)} target="_blank" rel="noopener noreferrer">
                                                            <Card>
                                                                <CardBody className="d-flex justify-content-center align-items-center">
                                                                    <Icon
                                                                        icon={fileDocumentEditOutline}
                                                                        color="#D6E0EC"
                                                                        width="120"
                                                                        height="80"
                                                                    />
                                                                </CardBody>
                                                                <CardFooter
                                                                    className="d-flex align-items-center justify-content-center"
                                                                    style={{
                                                                        overflow: 'hidden',
                                                                        maxHeight: '84px',
                                                                        minHeight: '84px',
                                                                    }}>
                                                                    <h4 className="text-center" style={{ textTransform: 'capitalize' }}>
                                                                        {form.label}
                                                                    </h4>
                                                                </CardFooter>
                                                            </Card>
                                                        </a>
                                                    )}
                                                </Col>
                                                ))
                                ) : (
                                    <div>No forms available</div>
                                )}
                            </Row>
                        </>
                    </ModalBody>
                </>
            ) : (
                ''
            )}
        </Modal>
    );
};

export default SecureFormsModal;